import { observer } from "mobx-react-lite/dist"
import { useProposalsEditServicesStore } from "./ProposalsEditServicesStore"
import Box from "@mui/material/Box"
import useStore from "reusable/mobx-store-utils/useStore"
import { ProposalStep2Dto } from "@gap/backend/app-services/proposal/models/ProposalStep2Dto"
import { useEffect } from "react"
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd"
import { arrayHasSameOrder } from "@gap/utils/utils"
import ProposalsEditServicesService from "./ProposalsEditServicesService"
import { themeConfig } from '@gap/shared/theme'

export default observer(function ProposalsEditServicesList() {
   const proposalsEditServicesStore = useProposalsEditServicesStore()

   const localStore = useStore(() => ({
      _services: [] as ProposalStep2Dto,
      get services() {
         return localStore._services
      },
      set services(services: ProposalStep2Dto) {
         // Ensure we have a copy, so we dont re-load our component when editing
         localStore._services = JSON.parse(JSON.stringify(services))
      }
   }))

   useEffect(() => {
      // Only update if a services has been added / removed
      // OR if the order has changed of the array (service dragged somewhere else)
      if (proposalsEditServicesStore.step.length !== localStore.services.length ||
         !arrayHasSameOrder(localStore.services, proposalsEditServicesStore.step, 'serviceId')) {
         localStore.services = proposalsEditServicesStore.step
      }
   }, [localStore, localStore.services.length, proposalsEditServicesStore.step])

   return <DragDropContext onDragEnd={proposalsEditServicesStore.onDragEnd}>
      <Droppable droppableId="dropIdForProposalServicesList">
         {(provided) => (
            <div
               {...provided.droppableProps}
               ref={provided.innerRef}
            >
               {
                  localStore.services.map((service, index) => {
                     return <Draggable key={service.serviceId} draggableId={service.serviceId} index={index}>
                        {(provided, snapshot) => (
                           <Box
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              sx={{
                                 boxShadow: snapshot.isDragging ? '0px 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                                 backgroundColor: snapshot.isDragging ? themeConfig.primary['200'] : 'transparent',
                                 mt: 2,
                              }}
                           >
                              <ProposalsEditServicesService service={service} dragHandleProps={provided.dragHandleProps} />
                           </Box>
                        )}
                     </Draggable>
                  })
               }
               {provided.placeholder}
            </div>
         )}
      </Droppable>
   </DragDropContext>
})
